import {
  CREATE_AUDIT_VOUCHER_SUCCESS,
  FETCH_AUDIT_VOUCHER_SUCCESS,
  GET_AUDIT_VOUCHER_SEARCH_END,
  GET_AUDIT_VOUCHER_SEARCH_START,
  GET_AUDIT_VOUCHER_SEARCH_SUCCESS,
  GET_AUDIT_VOUCHER_SUCCESS,
  SAVE_AUDIT_VOUCHER_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  auditVoucherSearchData: [],
  auditVoucherSearchLoading: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_AUDIT_VOUCHER_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_AUDIT_VOUCHER_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_AUDIT_VOUCHER_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_AUDIT_VOUCHER_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case GET_AUDIT_VOUCHER_SEARCH_SUCCESS: {
      return {
        ...state,
        auditVoucherSearchData: action.data,
        auditVoucherSearchLoading: false
      }
    }
    case GET_AUDIT_VOUCHER_SEARCH_END: {
      return { ...state, error: '', message: '', auditVoucherSearchLoading: false };
    }
    case GET_AUDIT_VOUCHER_SEARCH_START: {
      return { ...state, error: '', message: '', auditVoucherSearchLoading: true };
    }
    default:
      return state;
  }
}
